import { Nilable } from "@shared/utils";

export interface ICanjePremioDTO {
    created_at: string;
    email: string;
    id: number;
    prize: number;
    user: number;
    user_country: string;
    payload: Nilable<any>;
    quantity: number;
    state: string;
    user_id: number;
    user_email: string;
    user_balance: number;
    value: number;
    amazon_order: Nilable<string>;
    state_update: Nilable<string>;
    is_recycled: boolean;
}

export class CanjePremioDTO {
    public estadoActividad = "";
    public creadoEn = "";
    public email = "";
    public id = 0;
    public precio = 0;
    public panelista = 0;
    public panelistaPais = "";
    public payload: Nilable<any> = null;
    public cantidad = 0;
    public estado = "";
    public usuarioId = 0;
    public usuarioEmail = "";
    public usuarioBalance = 0;
    public valor = 0;
    public ordenAmazon: Nilable<string> = null;
    public actualizacionEstado: Nilable<string> = null;
    public esReciclado = false;

    constructor(json: Nilable<Partial<ICanjePremioDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICanjePremioDTO>) {
        if (json.created_at != null) {
            this.creadoEn = json.created_at;
        }
        if (json.email != null) {
            this.email = json.email;
        }
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.prize != null) {
            this.precio = json.prize;
        }
        if (json.user != null) {
            this.panelista = json.user;
        }
        if (json.user_country != null) {
            this.panelistaPais = json.user_country;
        }
        this.payload = json.payload;
        if (json.quantity != null) {
            this.cantidad = json.quantity;
        }
        if (json.state != null) {
            this.estado = json.state;
        }
        if (json.user_id != null) {
            this.usuarioId = json.user_id;
        }
        if (json.user_email != null) {
            this.usuarioEmail = json.user_email;
        }
        if (json.user_balance != null) {
            this.usuarioBalance = json.user_balance;
        }
        if (json.value != null) {
            this.valor = json.value;
        }
        if (json.amazon_order != null) {
            this.ordenAmazon = json.amazon_order;
        }
        if (json.state_update != null) {
            this.actualizacionEstado = json.state_update;
        }
        if (json.is_recycled) {
            this.esReciclado = json.is_recycled;
        }
    }

    public toJSON(): ICanjePremioDTO {
        return {
            created_at: this.creadoEn,
            email: this.email,
            id: this.id,
            prize: this.precio,
            user: this.panelista,
            user_country: this.panelistaPais,
            payload: this.payload,
            quantity: this.cantidad,
            state: this.estado,
            user_id: this.usuarioId,
            user_email: this.usuarioEmail,
            user_balance: this.usuarioBalance,
            value: this.valor,
            amazon_order: this.ordenAmazon,
            state_update: this.actualizacionEstado,
            is_recycled: this.esReciclado
        };
    }
}
